module.exports = __webpack_public_path__ + "assets/img/office-building-budapart-1920.390d21d7.webp";